import React from 'react';
import {
  composePurchaseRegNumber,
  composeSaleRegNumber,
} from '../../../../util/util.jsx';
import SupplierNameDisplayWrapper from '@/component/dict/simple/supplier/NameDisplayWrapper';
import BuyerNameDisplayWrapper from '@/component/dict/simple/buyer/NameDisplayWrapper';
export default class RegNumberElement extends React.Component {
  constructor(props) {
    super(props);
    this.showPurchaseRegNumber = this.showPurchaseRegNumber.bind(this);
    this.showSaleRegNumber = this.showSaleRegNumber.bind(this);
    this.updateLabels = this.updateLabels.bind(this);
    this.state = {
      regNumber: undefined,
      contratorName: undefined,
    };
    if (props.data) {
      this.updateLabels(props);
    }
  }

  componentWillReceiveProps(props) {
    if (props.data && props.data != this.props.data) {
      this.updateLabels(props);
    }
  }

  updateLabels(props) {
    this.state.regNumber = props.type == 'purchase'
      ? this.showPurchaseRegNumber(props.data)
      : this.showSaleRegNumber(props.data);

    if (props.type == 'purchase') {
      this.state.contratorName = props.data.get('supplier')
        ? <SupplierNameDisplayWrapper id={props.data.get('supplier')} />
        : undefined;
    }

    if (props.type == 'sale') {
      this.state.contratorName = props.data.get('buyer')
        ? <BuyerNameDisplayWrapper id={props.data.get('buyer')} />
        : undefined;
    }
  }

  showPurchaseRegNumber(data) {
    return composePurchaseRegNumber(data,
      'regNumber', 'Purchase');
  }

  showSaleRegNumber(data) {
    return composeSaleRegNumber(data,
      'regNumber', 'Sale');
  }

  render() {
    const contratorName = (<span
      className="text-primary"
      style={{
        whiteSpace: 'normal',
        fontWeight: 'bold',
        display: this.props.inline ? 'inline' : undefined,
        marginRight: this.state.contratorName ? '10px' : '0px',
      }}
    >
      {this.state.contratorName}
    </span>);
    const regNumber = (<span
      style={{
        display: 'inline',
      }}
    >
      <span>
        {this.state.regNumber}
      </span>
    </span>);
    return (!this.props.inline ?
      <div className={this.props.className || ''}>
        {contratorName}
        {regNumber}
      </div> :
      <span className={this.props.className || ''}>
        {contratorName}
        {regNumber}
      </span>
    );
  }
}

RegNumberElement.propTypes = {
  dealId: React.PropTypes.oneOfType([
    React.PropTypes.number,
    React.PropTypes.string,
  ]),
  data: React.PropTypes.object,
  type: React.PropTypes.string.isRequired,
  inline: React.PropTypes.bool,
  className: React.PropTypes.string,
};
